import { defineMessages } from 'react-intl';

const messages = defineMessages({
  serviceLabel: {
    defaultMessage: 'Service',
    id: '66yw5j',
    description: 'Rate Shopper picked service label',
  },
});

export default messages;
